export const MARKET_POSITIONING_BASELINE_COLOR = '#007aff';
export const MARKET_POSITIONING_GRID_LINE_COLOR = '#f1f1f1';
export const MARKET_POSITIONING_AXIS_TITLE_COLOR = '#222222';
export const MARKET_POSITIONING_TOOLTIP_TEXT_COLOR = '#ffffff';

export const MARKET_POSITIONING_LABEL_GUTTER = 8;
export const MARKET_POSITIONING_POINT_SIZE = 6;
export const MARKET_POSITIONING_POINT_LABEL_OFFSET_Y = 12;
export const MARKET_POSITIONING_POINT_LABEL_MAX_WIDTH = 130;
export const MARKET_POSITIONING_APPEND_PADDING = [10, 0, 12, 0] as const;

export const MARKET_POSITIONING_FALLBACK_QUALITY_MIN = 0;
export const MARKET_POSITIONING_FALLBACK_QUALITY_MAX = 5;
export const MARKET_POSITIONING_FALLBACK_RATE_MIN = 0;
export const MARKET_POSITIONING_FALLBACK_RATE_MAX = 6000;
export const MARKET_POSITIONING_RATE_MIN_MULTIPLIER = 0.9;
export const MARKET_POSITIONING_RATE_MAX_MULTIPLIER = 1.1;
export const MARKET_POSITIONING_QUALITY_PADDING_RATIO = 0.2;
export const MARKET_POSITIONING_QUALITY_PADDING_FALLBACK = 0.2;
